// extracted by mini-css-extract-plugin
export var center = "index-module--center--SVFPP";
export var container = "index-module--container--2GuoF";
export var logo = "index-module--logo--76E3v";